import { ThemeOptions } from "@mui/material";
import { HypeIcon } from "@ob/core";

const checkboxSize = 18;
export const muiCheckbox: ThemeOptions["components"] = {
  MuiCheckbox: {
    styleOverrides: {
      root: ({ theme }) => {
        return {
          "&.Mui-checked": {
            color: theme.palette.checkbox.default,
          },
          "&.Mui-disabled": {
            color: theme.palette.text.disabled,
          },
        };
      },
    },
    defaultProps: {
      icon: (
        <HypeIcon
          name="icon-check-false"
          size={checkboxSize}
          aria-label="unchecked"
        />
      ),
      checkedIcon: (
        <HypeIcon
          name="icon-check-true"
          size={checkboxSize}
          aria-label="checked"
        />
      ),
    },
  },
};
